const formatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

const divisions: Array<{ amount: number; unit: Intl.RelativeTimeFormatUnit }> = [
  { amount: 60, unit: 'second' },
  { amount: 60, unit: 'minute' },
  { amount: 24, unit: 'hour' },
  { amount: 7, unit: 'day' },
  { amount: 4.34524, unit: 'week' },
  { amount: 12, unit: 'month' },
  { amount: Infinity, unit: 'year' },
];

export function formatRelative(date: Date, now: Date = new Date()): string {
  const diffSeconds = (date.getTime() - now.getTime()) / 1000;

  if (Math.abs(diffSeconds) < 45) {
    return 'just now';
  }

  let value = diffSeconds;

  for (const division of divisions) {
    if (Math.abs(value) < division.amount) {
      return formatter.format(Math.round(value), division.unit);
    }

    value /= division.amount;
  }

  return formatter.format(Math.round(value), 'year');
}
